import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Layout from "../../layouts/s22_page"

import { StyledPage } from "./partials"
import { globalDataType, pageBlokType } from "../../types"

export interface PageProps {
  blok: pageBlokType
  path: string
  story: any
}

const S22Page: React.FC<PageProps> = ({ blok, path, story }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allStoryblokEntry(filter: {field_component: { eq: "global" }}) {
            edges {
              node {
                id
                name
                created_at
                uuid
                slug
                full_slug
                content
                is_startpage
                parent_id
                group_id
              }
            }
          }
        }
      `}
      render={(data) => {
        const globalData: globalDataType = JSON.parse(
          data.allStoryblokEntry.edges[0].node.content
        )
        return (
          <StyledPage>
            <Layout globalData={globalData} blok={blok} path={path} story={story} />
          </StyledPage>
        )
      }}
    />
  )
}

export default S22Page
